import _ from "underscore";

function toggleClassFromErrors(errorsForAttribute, type, el) {
  const targetFormGroup = el.closest(".sb-field-group");

  if (targetFormGroup.length) {
    // Warnings are mapped to invalid for now
    targetFormGroup.toggleClass('sb-field-group--invalid', !!errorsForAttribute);
  } else {
    el.closest(".form-group").toggleClass(`has-${type}`, !!errorsForAttribute);
  }
}

export function bindErrorsToFormField(name, attr, options) {
  return bindMessageToFormField("error", name, attr, options);
}

export function bindWarningsToFormField(name, attr, options) {
  return bindMessageToFormField("warning", name, attr, options);
}

export function bindMessageToFormField(type, name, attr, options) {
  let prefix = '';
  if (!options || options.addPrefix) {
    prefix = `${name} `;
  }

  return {
    observe: `${type}s`,

    update($el, errorHash, model, options) {
      const errorsForAttribute = errorHash[attr];
      if (errorsForAttribute) {
        $el.text(prefix + _.flatten([errorsForAttribute]).join(", "));
      } else {
        $el.text("");
      }

      toggleClassFromErrors(errorsForAttribute, type, $el);
    }
  };
}
